import Sidenav from '../../utils/AdminSidebar';

export default function Admin({user_id}) {
    console.log("Admin+++++++", user_id);
    return (
            <Sidenav user_id={user_id} />
    );
}